<template>
  <de-layout-content>
    <div class="structureContent">
      <div class="leftNav">
        <!-- <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item
            :title="item.packageName"
            :name="item.packageName"
            v-for="(item, index) in navList"
            :key="index"
          >

            <div
              :class="[
                'navItem',
                `${index}-${childIndex}` == navIndex ? 'active' : '',
              ]"
              v-for="(childItem, childIndex) in item.list"
              :key="childIndex"
              @click="selectChildItem(item, index, childItem, childIndex)"
            >
              {{ childItem.tableComment }}
            </div>
          </el-collapse-item>
        </el-collapse> -->

        <!-- <Tree></Tree> -->

        <div class="block">
          <div class="treeHeader">
            <i class="el-icon-s-shop"></i>
            <span style="margin-left: 6px">档案指标</span>
          </div>

          <el-tree
            ref="datasetTreeRef"
            :data="navList"
            highlight-current
            :props="{
              label: 'label',
              children: 'list',
            }"
            node-key="nodeDiyId"
            :default-expanded-keys="expandedArray"
            @node-click="nodeClick"
          >
          </el-tree>
        </div>
      </div>
      <div class="mainCon">
        <div class="search">
          <el-input
            placeholder="搜索指标"
            prefix-icon="el-icon-search"
            v-model="fieldComment"
            style="width: 208px"
            @blur="searchValue"
          >
          </el-input>
        </div>
        <div class="levelLine" v-for="(item, index) in tableData" :key="index">
          <div class="levelHeader">
            {{ item.indexType }}
          </div>
          <el-table :data="item.list" border style="width: 100%">
            <el-table-column prop="fieldName" label="指标名称" align="center">
              <template slot-scope="scope">
                <!-- <el-input
                  v-model="scope.row.fieldName"
                  @blur="inputBlur(scope.row)"
                  placeholder="指标名称"
                ></el-input> -->
                <span>{{ scope.row.fieldName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位" align="center"></el-table-column>
            <el-table-column
              prop="field"
              label="原始名称"
              align="center"
            ></el-table-column>
            <el-table-column prop="getType" label="指标获取方式" align="center">
            </el-table-column>
            <el-table-column prop="dataType" label="指标类型" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.dataType | getTicketType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="说明"
              align="center"
            ></el-table-column>
            <el-table-column prop="action" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  plain
                  type="primary"
                  @click="hallAddEdit(scope.row)"
                  >编辑</el-button
                >
                <el-popconfirm
                  title="确定删除吗？该操作不会撤销"
                  @confirm="handleDelete(scope.row)"
                >
                  <el-button
                    slot="reference"
                    size="small"
                    type="danger"
                    plain
                    style="margin-left: 10px"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <el-button
              style="width: 100%; color: #1890ff; margin: 1px 0 4px 0"
              @click="addAction(item, index)"
              >+添加指标</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="formData.id ? '修改指标' : '添加指标'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
      >
        <div v-if="formData.id">
          <el-form-item label="指标获取方式:" prop="getType">
            <el-checkbox-group v-model="formData.getType">
              <el-checkbox label="添加"></el-checkbox>
              <el-checkbox label="上传"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="说明:">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="formData.remark"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="指标名称:" prop="fieldName">
            <el-input
              v-model="formData.fieldName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
            <el-form-item label="单位:" prop="unit">
              <el-input v-model="formData.unit" autocomplete="off"></el-input>
            </el-form-item>
          <el-form-item label="指标获取方式:" prop="getType">
            <el-checkbox-group v-model="formData.getType">
              <el-checkbox label="添加"></el-checkbox>
              <el-checkbox label="上传"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="指标类型:" prop="dataType">
            <el-radio-group v-model="formData.dataType">
              <el-radio label="double">数字</el-radio>
              <el-radio label="pic">图片</el-radio>
              <el-radio label="varchar">多行文本</el-radio>
              <el-radio label="fulltext">单行文本</el-radio>
              <el-radio label="date">日期</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="说明:">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="formData.remark"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('formData')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </de-layout-content>
</template>

<script>
// import Tree from "./tree.vue";
import * as API_Member from "@/api/member/member";
import { log } from "@antv/g2plot/lib/utils";
export default {
  data() {
    return {
      fieldComment: "", // 指标名称
      navIndex: "0-0",
      dialogFormVisible: false,
      formData: {
        getType: ["添加", "上传"],
        dataType: "double",
      },
      activeNames: ["生理生化"],
      navList: [],
      tableData: [],
      expandedArray: [],
      rules: {
        fieldName: [
          { required: true, message: "请输入指标名称", trigger: "change" },
        ],
        unit: [{ required: true, message: "请输入单位", trigger: "change" }],
        getType: [
          { required: true, message: "请选择指标获取方式", trigger: "change" },
        ],
        dataType: [
          { required: true, message: "请选择指标类型", trigger: "change" },
        ],
      },
      formParams: {},
      selectNavTableCommentParams: {},
      selectNavPackageParams: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getFieldNavigationTreeList();
    },
    async getFieldNavigationTreeList() {
      let res = await API_Member.fieldNavigationTreeList({});
      if (res.code === 200) {
        this.navList = res.data;
        res.data.forEach((item, index) => {
          item.label = item.packageName;
          item.nodeDiyId = `${index}`;
          item.list.forEach((cItem, cIndex) => {
            cItem.label = cItem.tableComment;
            cItem.nodeDiyId = `${index}-${cIndex}`;
          });
        });

        this.getFieldDetailTreeList(res.data[0].list[0]);
        this.$nextTick(() => {
          this.expandedArray = [this.navList[0].nodeDiyId];
          this.$refs.datasetTreeRef.setCurrentKey(
            this.navList[0].list[0].nodeDiyId
          );
        });
        console.log(this.navList);
      }
    },
    handleChange(val) {
      console.log(val);
    },
    searchValue() {
      this.getFieldDetailTreeList(this.selectNavTableCommentParams);
    },
    selectChildItem(item, index, childItem, childIndex) {
      console.log(item, index, childItem, childIndex);
      this.navIndex = `${index}-${childIndex}`;
      this.selectNavPackageParams = item;
      this.selectNavTableCommentParams = childItem;
      this.getFieldDetailTreeList(childItem);
    },
    nodeClick(data, node, e) {
      console.log(data, node);
      if (node.level == 2) {
        this.selectNavPackageParams = node.parent.data;
        this.selectNavTableCommentParams = data;
      }
      if (node.level == 1) {
        this.selectNavPackageParams = data;
        this.selectNavTableCommentParams = data.list[0];
      }
      console.log(this.selectNavPackageParams, "this.selectNavPackageParams");
      console.log(
        this.selectNavTableCommentParams,
        "this.selectNavTableCommentParams"
      );
      this.getFieldDetailTreeList(this.selectNavTableCommentParams);
    },
    getFieldDetailTreeList(value) {
      API_Member.fieldDetailTreeList({
        pageNum: 1,
        pageSize: 10,
        tableComment: value.tableComment,
        fieldComment: this.fieldComment || "",
      }).then((res) => {
        console.log(res);
        this.tableData = res.data;
      });
    },
    addAction(item, index) {
      console.log(item, index);
      this.dialogFormVisible = true;
      this.formParams = item;
      this.formData = {
        getType: ["添加", "上传"],
        dataType: "double",
      };
    },
    // 编辑
    hallAddEdit(row) {
      console.log(row);
      this.dialogFormVisible = true;
      this.formData = {
        ...row,
        getType: row.getType ? row.getType.split(",") : [],
      };
      console.log(this.formData);
    },
    inputBlur(row) {
      console.log(row);
      let data = {
        ...row,
      };
      console.log(data);
      API_Member.fieldEdit(data).then((res) => {
        console.log(res);
        this.getFieldDetailTreeList(this.selectNavTableCommentParams);
      });
    },

    // 删除
    handleDelete(e) {},

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.formParams, "formParams");
          console.log(
            this.selectNavTableCommentParams,
            "selectNavTableCommentParams"
          );
          let data = {
            ...this.formData,
            getType: this.formData.getType.join(","),
            indexType: this.formData.id
              ? this.formData.indexType
              : this.formParams.indexType,
            tableComment:
              this.selectNavTableCommentParams.tableComment ||
              this.navList[0].list[0].tableComment,
            packet:
              this.selectNavPackageParams.packageName ||
              this.navList[0].packageName,
          };
          console.log(data);
          if (data.id) {
            API_Member.fieldEdit(data).then((res) => {
              console.log(res);
              this.dialogFormVisible = false;
              this.getFieldDetailTreeList(this.selectNavTableCommentParams);
            });
          } else {
            API_Member.fieldAdd(data).then((res) => {
              console.log(res);
              this.dialogFormVisible = false;
              this.getFieldDetailTreeList(this.selectNavTableCommentParams);
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  filters: {
    getTicketType(val) {
      console.log(val);
      switch (val) {
        case "double":
          return "数字";
        case "pic":
          return "图片";
        case "varchar":
          return "多行文本";
        case "fulltext":
          return "单行文本";
        case "date":
          return "日期";
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-tree-node__expand-icon.is-leaf {
  visibility: hidden;
}
.filePointer {
  width: 100%;
  height: 100%;
}
.structureContent {
  display: flex;
  height: 100%;
  .leftNav {
    width: 220px;
    background-color: #141937;
    // border: 1px solid #e6e6e6;
    // border-right: 1px solid #e6e6e6;
    // border-left: 1px solid #e6e6e6;
    margin-right: 22px;
    .treeHeader {
      display: flex;
      align-items: center;
      // height: 40px;
      margin-bottom: 10px;
      // padding: 0 12px;
      color: #fff;
    }
    .navItem {
      height: 52px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .active {
      background-color: rgba(247, 250, 253, 1);
      color: rgb(64, 158, 255);
    }
    ::v-deep .el-tree-node__content {
      height: 40px;
    }
    ::v-deep
      .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      color: rgb(64, 158, 255);
    }
  }

  .mainCon {
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
    .search {
      margin-bottom: 22px;
    }
    .levelHeader {
      // padding: 0 12px;
      height: 36px;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      // background-color: rgba(240, 247, 255, 1);
    }
    .levelLine {
      .el-button {
        background-color: inherit !important;
        border-radius: 0 !important;
        border: 1px solid #1890ff !important;
        color: #1890ff !important;
        &:hover {
          background-color: #1890ff !important;
          color: #fff !important;
        }
      }
    }
  }
}
</style>
